import { CheckoutRepository } from '@lib/api/repository/checkout/checkout.repository';
import {
  CheckoutBatchInput,
  CheckoutSessionInput,
  ShippingQuoteInput,
} from '@lib/types';

export default class CheckoutService {
  constructor(private repository: CheckoutRepository) {}
  createBatch(input: CheckoutBatchInput) {
    return this.repository.createBatch(input);
  }

  getAvailability(signal?: AbortSignal) {
    return this.repository.getAvailability(signal);
  }

  quoteShipping(input: ShippingQuoteInput) {
    return this.repository.quoteShipping(input);
  }

  createSession(input: CheckoutSessionInput) {
    return this.repository.createSession(input);
  }

  resumeOrderPayment(orderId: string) {
    return this.repository.resumeOrderPayment(orderId);
  }

  findSession(id: string, signal?: AbortSignal) {
    return this.repository.findSession(id, signal);
  }
}
